import { render } from "./ListaComponent.vue?vue&type=template&id=2e46d018"
import script from "./ListaComponent.vue?vue&type=script&lang=js"
export * from "./ListaComponent.vue?vue&type=script&lang=js"

import "./ListaComponent.vue?vue&type=style&index=0&id=2e46d018&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__